import { useMutation } from '@tanstack/react-query';
import { useAuthStore } from '../stores/auth.store';
import { login, logout } from '../api/auth.api';

export function useLogin() {
  const setAuth = useAuthStore((s) => s.setAuth);
  return useMutation({
    mutationFn: ({ email, password }: { email: string; password: string }) => login(email, password),
    onSuccess: (data) => setAuth(data.accessToken, data.user),
  });
}

export function useLogout() {
  const clearAuth = useAuthStore((s) => s.clearAuth);
  return useMutation({
    mutationFn: logout,
    onSettled: () => clearAuth(),
  });
}
